import { Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { ReactNode } from "react";

interface Props {
  title: ReactNode;
  subtitle?: string | null;
  textAlign?: "start" | "center" | "end";
  className?: string;
}

export function AppTitle(props: Props) {
  const { title, subtitle, textAlign, className } = props;

  return (
    <div
      className={css(
        {
          display: "flex",
          flexDirection: "column",
          gap: "var(--space-1)",
          textAlign,
        },
        className
      )}
    >
      <Text as="h1" style="form/page-title" testID="dashboard-title">
        {title}
      </Text>
      {subtitle && (
        <Text
          style="global/body-secondary"
          color="text-weak"
          testID="dashboard-subtitle"
        >
          {subtitle}
        </Text>
      )}
    </div>
  );
}
